(function () {
    if (window.__resourceAccessInit) {
        return;
    }
    window.__resourceAccessInit = true;

    const modal = document.getElementById('resourceAccessModal');
    const configEl = document.getElementById('resourceAccessConfig');
    if (!modal || !configEl) {
        return;
    }

    let config = {};
    try {
        config = JSON.parse(configEl.textContent || '{}');
    } catch (error) {
        config = {};
    }

    const titleEl = document.getElementById('resourceAccessModalTitle');
    const messageEl = document.getElementById('resourceAccessModalMessage');
    const iconEl = document.getElementById('resourceAccessModalIcon');
    const actionsEl = document.getElementById('resourceAccessModalActions');
    const closeButtons = modal.querySelectorAll('[data-resource-access-close]');
    let lastFocusedElement = null;
    const triggeredForm1042 = {};

    const FALLBACK_VARIANTS = {
        login: {
            title: 'Login to access',
            messageTemplate: '{title} requires a free member account. Register or login to view and download.',
            icon: { type: 'class', class: 'far fa-lock' },
            iconModifier: 'login',
            buttons: [
                { label: 'Register for Free', action: 'link', urlKey: 'register', appendReturn: true, className: 'btn btn-primary' },
                { label: 'Login', action: 'link', urlKey: 'login', appendReturn: true, className: 'btn btn-outline-primary' },
            ],
        },
        retainer_guest: {
            title: 'Retainer exclusive resource',
            messageTemplate: '{title} is exclusive to retainer clients. Register for a free account to explore the library, or login if you already have one.',
            icon: { type: 'class', class: 'far fa-shield-check' },
            iconModifier: 'retainer',
            buttons: [
                { label: 'Register for Free', action: 'link', urlKey: 'register', appendReturn: true, className: 'btn btn-primary' },
                { label: 'Login', action: 'link', urlKey: 'login', appendReturn: true, className: 'btn btn-outline-primary' },
            ],
        },
        retainer_member: {
            title: 'Retainer exclusive resource',
            messageTemplate: '{title} is exclusive to retainer clients. Contact us to find out more about retainer HR support.',
            icon: { type: 'class', class: 'far fa-shield-check' },
            iconModifier: 'retainer',
            buttons: [
                { label: 'Contact us', action: 'link', urlKey: 'contact', className: 'btn btn-primary' },
                { label: 'Close', action: 'dismiss', className: 'btn btn-outline-secondary' },
            ],
        },
    };

    // ActiveCampaign hosted form 1042 (download gate) — silent submit, no embed.
    const AC_FORM_1042 = {
        url: 'https://dakotablue.activehosted.com/proc.php',
        or: 'bd63161731e414847aae8f37f22d4543',
    };

    function decodeHtmlEntities(value) {
        if (!value) {
            return '';
        }
        const textarea = document.createElement('textarea');
        textarea.innerHTML = value;
        return textarea.value;
    }

    function canAccess(access) {
        const level = (access || 'public').toLowerCase();
        if (level === 'public' || level === '') {
            return true;
        }
        if (!config.isLoggedIn) {
            return false;
        }
        if (level === 'member') {
            return true;
        }
        return !!config.hasRetainerRole;
    }

    function deniedReason(access) {
        if (canAccess(access)) {
            return null;
        }
        const level = (access || 'public').toLowerCase();
        if (!config.isLoggedIn) {
            return 'login';
        }
        if (level === 'retainer') {
            return 'retainer';
        }
        return 'login';
    }

    function canDownloadResource(access) {
        if (!config.isLoggedIn) {
            return false;
        }
        return canAccess(access);
    }

    function downloadDeniedReason(access) {
        if (canDownloadResource(access)) {
            return null;
        }
        const level = (access || 'public').toLowerCase();
        if (level === 'retainer') {
            return 'retainer';
        }
        return 'login';
    }

    function resolveVariant(reason) {
        const key = (reason || 'login').toLowerCase();
        if (key === 'retainer') {
            return config.isLoggedIn ? 'retainer_member' : 'retainer_guest';
        }
        return 'login';
    }

    function getVariantConfig(variantKey) {
        const variants = config.variants || {};
        return variants[variantKey] || FALLBACK_VARIANTS[variantKey] || FALLBACK_VARIANTS.login;
    }

    function applyMessageTemplate(template, resourceTitle) {
        const text = (template || '').trim();
        if (!text) {
            return '';
        }
        const titleText = (resourceTitle || '').trim();
        const replacement = titleText ? '"' + titleText + '"' : 'This resource';
        return text.split('{title}').join(replacement);
    }

    function withReturn(url, returnUrl) {
        const target = returnUrl || config.returnUrl || window.location.pathname;
        const separator = url.indexOf('?') >= 0 ? '&' : '?';
        return url + separator + 'return=' + encodeURIComponent(target);
    }

    function resolveUrlKey(urlKey) {
        switch ((urlKey || '').toLowerCase()) {
            case 'register':
                return config.registerUrl || '/register';
            case 'login':
                return config.loginUrl || '/login';
            case 'contact':
                return config.contactUrl || '/contact-us/';
            default:
                return '';
        }
    }

    function resolveButtonHref(button, returnUrl) {
        if (button.href) {
            return button.href;
        }
        const href = resolveUrlKey(button.urlKey);
        if (!href) {
            return '#';
        }
        if (button.appendReturn) {
            return withReturn(href, returnUrl);
        }
        return href;
    }

    function createButton(label, href, className) {
        const link = document.createElement('a');
        link.className = className || 'btn btn-primary';
        link.textContent = label;
        link.href = href;
        return link;
    }

    function createDismissButton(label, className) {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = className || 'btn btn-outline-secondary';
        button.textContent = label;
        button.addEventListener('click', closeModal);
        return button;
    }

    function setIcon(iconConfig, modifier) {
        if (!iconEl) {
            return;
        }

        const iconModifier = modifier || 'login';
        iconEl.className = 'resource-access-modal__icon resource-access-modal__icon--' + iconModifier;
        iconEl.innerHTML = '';

        const icon = iconConfig || {};
        if (icon.type === 'image' && icon.src) {
            const image = document.createElement('img');
            image.src = icon.src;
            image.alt = icon.alt || '';
            image.className = 'resource-access-modal__icon-image';
            iconEl.appendChild(image);
            return;
        }

        const iconClass = icon.class || 'far fa-lock';
        const iconElement = document.createElement('i');
        iconClass.split(/\s+/).forEach(function (className) {
            if (className) {
                iconElement.classList.add(className);
            }
        });
        iconElement.setAttribute('aria-hidden', 'true');
        iconEl.appendChild(iconElement);
    }

    /**
     * Fire AC form 1042 once per resource for the logged-in user.
     * Uses fetch (not JSONP) so AC thank-you / redirect scripts never run on this page.
     */
    function triggerActiveCampaignForm1042(resourceId) {
        const email = (config.email || '').trim();
        if (!email || !config.isLoggedIn) {
            return;
        }

        const key = String(resourceId || '') + '|' + email.toLowerCase();
        if (triggeredForm1042[key]) {
            return;
        }
        triggeredForm1042[key] = true;

        const body = new URLSearchParams();
        body.set('u', '1042');
        body.set('f', '1042');
        body.set('s', '');
        body.set('c', '0');
        body.set('m', '0');
        body.set('act', 'sub');
        body.set('v', '2');
        body.set('or', AC_FORM_1042.or);
        body.set('firstname', config.firstName || '');
        body.set('lastname', config.lastName || '');
        body.set('email', email);
        body.set('field[11]', resourceId ? String(resourceId) : '');

        // no-cors: submit succeeds without reading/evaluating AC's response JS
        fetch(AC_FORM_1042.url, {
            method: 'POST',
            body: body,
            mode: 'no-cors',
            keepalive: true,
            credentials: 'omit',
        }).catch(function () {
            triggeredForm1042[key] = false;
        });
    }

    function showModal(type, options) {
        const reason = type || 'login';
        const returnUrl = (options && options.returnUrl) || config.returnUrl || window.location.pathname;
        const resourceTitle = decodeHtmlEntities((options && options.title) || '');
        const resourceId = (options && options.resourceId) || config.resourceId || '';
        const variantKey = resolveVariant(reason);
        const variant = getVariantConfig(variantKey);

        if (!titleEl || !messageEl || !actionsEl) {
            return;
        }

        actionsEl.innerHTML = '';
        setIcon(variant.icon, variant.iconModifier || (variantKey.indexOf('retainer') === 0 ? 'retainer' : 'login'));
        titleEl.textContent = variant.title || '';
        messageEl.textContent = applyMessageTemplate(variant.messageTemplate, resourceTitle);

        (variant.buttons || []).forEach(function (button) {
            if (!button || !button.label) {
                return;
            }
            if (button.action === 'dismiss') {
                actionsEl.appendChild(createDismissButton(button.label, button.className));
                return;
            }
            actionsEl.appendChild(createButton(
                button.label,
                resolveButtonHref(button, returnUrl),
                button.className
            ));
        });

        if (variantKey === 'retainer_member') {
            triggerActiveCampaignForm1042(resourceId);
        }

        lastFocusedElement = document.activeElement;
        modal.hidden = false;
        modal.setAttribute('aria-hidden', 'false');
        document.body.classList.add('resource-access-modal-open');

        const closeButton = modal.querySelector('.resource-access-modal__close');
        if (closeButton) {
            closeButton.focus();
        }
    }

    function closeModal() {
        modal.hidden = true;
        modal.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('resource-access-modal-open');

        if (lastFocusedElement && typeof lastFocusedElement.focus === 'function') {
            lastFocusedElement.focus();
        }
    }

    closeButtons.forEach(function (button) {
        button.addEventListener('click', closeModal);
    });

    document.addEventListener('keydown', function (event) {
        if (modal.hidden) {
            return;
        }
        if (event.key === 'Escape') {
            event.preventDefault();
            closeModal();
        }
    });

    document.addEventListener('click', function (event) {
        const downloadLink = event.target.closest('.resource-detail__download-link');
        if (downloadLink && downloadLink.href) {
            event.preventDefault();
            window.open(downloadLink.href, '_blank', 'noopener,noreferrer');
            return;
        }

        const downloadGate = event.target.closest('.resource-detail__download-gate');
        if (downloadGate) {
            event.preventDefault();
            const access = (downloadGate.getAttribute('data-access') || 'public').toLowerCase();
            const reason = downloadDeniedReason(access);
            if (!reason) {
                return;
            }
            showModal(reason, {
                returnUrl: config.returnUrl || window.location.pathname,
                title: decodeHtmlEntities(downloadGate.getAttribute('data-title') || ''),
                resourceId: downloadGate.getAttribute('data-resource-id') || '',
            });
            return;
        }

        const card = event.target.closest('.resource-card[data-access]');
        if (card && card.classList.contains('resource-card--download')) {
            return;
        }
        const faqResourceLink = event.target.closest('.resource-challenge-faqs__resource-link[data-access]');
        const challengeBtn = event.target.closest('.resource-challenges__btn[data-access]');
        const target = card || faqResourceLink || challengeBtn;
        if (!target) {
            return;
        }

        const access = (target.getAttribute('data-access') || 'public').toLowerCase();
        if ((card || faqResourceLink) && access === 'retainer') {
            return;
        }

        if (canAccess(access)) {
            return;
        }

        event.preventDefault();
        showModal(deniedReason(access), {
            returnUrl: target.getAttribute('href') || window.location.pathname,
            title: decodeHtmlEntities(target.getAttribute('data-title') || ''),
            resourceId: target.getAttribute('data-resource-id') || '',
        });
    }, true);

    window.ResourceAccess = {
        show: showModal,
        close: closeModal,
        canAccess: canAccess,
    };

    if (config.autoShow) {
        window.requestAnimationFrame(function () {
            showModal(config.autoShow, {
                returnUrl: config.returnUrl || window.location.pathname,
                title: decodeHtmlEntities(config.resourceTitle || ''),
                resourceId: config.resourceId || '',
            });
        });
    }
}());
